let language = localStorage.getItem("selectedLanguage");
let label;
if (language && language === "En") {
  label = {
    page: {
      home: "Home",
      dashboard: "Dashboard",
      aboutUs: "About Us",
      contactUs: "Contact Us",
      baseInformation: "Base Informations",
      users: "Users",
      products: "Products",
      addProduct: "New Product",
      editProduct: "Edit Product",
      orders: "Orders",
      addOrder: "New Order",
      editOrder: "Edit Order",
      support: "Support",
      tickets: "Tickets",
      addTicket: "Open Ticket",
      messages: "Messages",
      profile: "Profile",
      login: "Sign In",
      register: "Sign Up",
      notFound: "Oops! Are You Lost ?!",
      notAccess: "Sorry! You Don't Have Access To This Page",
      noAccess: "No Access",
      serverError: "Internal Server Error! Please Call The Technical Support",
      underConstruction:
        "This Page is Under Construction and will be Available Soon",
    },
    menu: {
      home: "Home",
      dashboard: "Dashboard",
      about: "About Us",
      contact: "Contact Us",
      users: "Users",
      messages: "Messages",
      tickets: "Tickets",
      support: "Support",
      products: "Products",
      manageProducts: "Products Management",
      orders: "Orders",
      addOrder: "New Order",
      cart: "Cart",
      shop: "Shop",
      baseInformation: "Base Informations",
      reports: "Reports",
      editProfile: "Update Profile",
      notifications: "Notifications",
      allNotifications: "Show all Notifications",
      allMessages: "Show all Messages",
      logout: "Logout",
      rejectedTemplate: "Blocked Account",
    },
    button: {
      login: "Sign In",
      register: "Sign Up",
      logout: "Logout",
      recoveryEmail: "Send Recovery Email",
      submit: "Submit",
      submitInfo: "Submit Informations",
      save: "Save",
      saveChanges: "Save Changes",
      add: "Add New",
      addUser: "New User",
      edit: "Update",
      delete: "Delete",
      confirmDelete: "Yes, Delete",
      editProfile: "Update Profile",
      editPassword: "Update Password",
      send: "Send",
      back: "Back",
      backToLogin: "Back to Login",
      backToHome: "Back to Home",
      home: "Home",
      cancel: "Cancel",
      addBase: "Add Base Info",
      reload: "Reload",
      addProduct: "Save Product",
      editProduct: "Update Profile",
    },
    table: {
      row: "#",
      actions: "Actions",
      title: "Title",
      qty: "Quantity",
      category: "Category",
      subject: "Subject",
      status: "Status",
      name: "Full Name",
      username: "Username",
      city: "City",
      role: "User Role",
      active: "Active",
      inactive: "Inactive",
    },
    form: {
      firstName: "First Name",
      lastName: "Last Name",
      fullName: "Full Name",
      userName: "Username",
      password: "Password",
      repeatPassword: "Repeat Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      email: "Email Address",
      mobile: "Mobile Number",
      tel: "Phone Number",
      phone: "Telephone",
      address: "Address",
      zipCode: "Zip Code",
      otpCode: "OTP Code",
      image: "Image",
      file: "File",
      fileSize: "Max File Size",
      fileType: "File Types",
      fileRatio: "Better To Use Square Ratio Picture",
      department: "Department",
      birthDate: "Birth Date",
      description: "Description",
      content: "Content",
      message: "Message",
      subject: "Subject",
      title: "Title",
      qty: "Quantity",
      digit: "Digit",
      category: "Category",
      city: "City",
      role: "User Role",
      productName: "Product Name",
      annualDemand: "Annual Demand",
      sbu: "SBU",
      resell: "Resell",
      weight: "Special Weight",
      sendDate: "Sent Date",
      productDate: "Production Date",
      paymentMethod: "Payment Method",
      cashOption: "Cash",
      chequeOption: "Cheque",
      attachment: "Attachment",
      dropzoneTxt: "Click or Drop File here",
    },
    caption: {
      yes: "Yes",
      no: "No",
      ok: "Ok",
      dashboard: "Dashboard",
      profile: "Update Profile",
      password: "Change Password",
      avatar: "Profile Avatar",
      baseInformation: "Basic Informations",
      addBaseInformation: "Add Basic Info",
      editBaseInformation: "Update Basic Info",
      users: "Users Management",
      addUser: "New User",
      editUser: "Update User",
      products: "Products Management",
      orders: "Manage Orders",
      messages: "Messages and Chats",
      tickets: "Tickets",
      loading: "Loading ...",
      singIn: "Sign in",
      singUp: "Sign Up",
      haveAccount: "Do you have Account ?",
      haveNotAccount: "Don't have Account ?",
      forgotPassword: "Forgot Password ?",
      emptyItem: "Item Not Found",
      emptyMessage: "There is no Message",
      emptyTicket: "There is no Tickets",
      emptyNotify: "There is no new Notifications",
      noMessage: "There is no new Message",
      noNotify: "There is no new Notification",
      underConstruction:
        "This Section is Under Construction and will be available soon",
      rejectedTitle: "No Access",
      rejectedText: "Your Account has been blocked or Reported",
      search: "Search",
      searchTable: "Search Items",
      searchAllColumns: "Search in all columns",
      delConfirm: "Are you sure you want to delete this item ?",
      resell: "is this Item for Resell ?",
    },
  };
} else {
  label = {
    page: {
      home: "صفحه اصلی",
      dashboard: "داشبورد",
      aboutUs: "درباره ما",
      contactUs: "تماس با ما",
      baseInformation: "اطلاعات پایه",
      users: "کاربران و پرسنل",
      products: "محصولات و تولیدات",
      addProduct: "ثبت محصول",
      editProduct: "ویرایش اطلاعات محصول",
      orders: "سفارشات مشتریان",
      addOrder: "ثبت سفارش",
      editOrder: "ویرایش سفارش",
      support: "پشتیبانی",
      tickets: "تیکت پشتیبانی",
      addTicket: "ثبت تیکت پشتیبانی",
      messages: "پیام‌ها",
      profile: "پروفایل کاربری",
      login: "ورود به سامانه",
      register: "عضویت",
      notFound: "راهتان را گم کرده‌اید ؟!",
      notAccess: "متأسفانه دسترسی شما برای مشاهده این قسمت محدود شده است",
      noAccess: "عدم دسترسی",
      serverError: "خطای ارتباط با سرور؛ لطفا به پشتیبانی فنی اطلاع دهید",
      underConstruction: "صفحه مدنظر در حال توسعه و برورسانی می‌باشد",
      fiscalYear: "سال مالی",
      setting: "تنظیمات",
      activityGroup: "گروه فعالیت",
      internalUnit: "واحد داخلی",
      country: "لیست کشور ها",
      province: "لیست استان ها",
      city: "لیست شهر ها",
      user: "کاربران",
      addUser: "ثبت کاربر جدید",
      editUser: "ویرایش اطلاعات کاربر",
      roles: "نقش‌های کاربران",
      permissions: "مدیریت دسترسی‌ها",
      person: "اشخاص",
      automationType: "انواع اتوماسیون",
      vehicle: "وسیله نقلیه",
      billboard: "بیلبورد",
      addBillboard: "ثبت بیلبورد جدید",
      editBillboard: "ویرایش اطلاعات بیلبورد",
      serviceType: "انواع خدمات",
      tariff: "تعرفه‌ها",
      addTariff: "ثبت تعرفه جدید",
      editTariff: "ویرایش اطلاعات تعرفه",
      waterBillPeriod: "دوره‌های قبض آب",
      subscriber: "مشترکین",
      addSubscriber: "ثبت مشترک جدید",
      editSubscriber: "ویرایش اطلاعات مشترک",
      notice: "اطلاعیه ها",
      addNotice: "ثبت اطلاعیه‌ جدید",
      editNotice: "ویرایش اطلاعات اطلاعیه‌",
      transit: "ترددها",
      addTransit: "ثبت تردد جدید",
      editTransit: "ویرایش اطلاعات تردد",
      fieldReport: "گزارش میدانی",
      meterReading: "قرائت",
      waterBill: "قبض آب",
      editWaterBill: "ویرایش اطلاعات قبض آب",
      chargeBill: "قبض شارژ",
      automation: "اتوماسیون",
      addAutomation: "ثبت اتوماسیون جدید",
      editAutomation: "ویرایش اطلاعات اتوماسیون",
      billboardRequest: "درخواست بیلبورد",
      addBillboardRequest: "ثبت درخواست بیلبورد جدید",
      editBillboardRequest: "ویرایش اطلاعات درخواست بیلبورد",
      serviceRequest: "درخواست خدمات",
      addServiceRequest: "ثبت درخواست خدمت جدید",
      editServiceRequest: "ویرایش اطلاعات درخواست خدمت",
      addFieldReport: "ثبت گزارش میدانی جدید",
      editFieldReport: "ویرایش اطلاعات گزارش میدانی",
      editChargeBill: "ویرایش اطلاعات قبض شارژ",
      transactionReport: "گزارش پرداخت ها",
      transactionInfo: "تنظیم تراکنشات",
      voucherCartable: "کارتابل صدور سند",
    },
    menu: {
      home: "صفحه اصلی",
      dashboard: "داشبورد",
      about: "درباره ما",
      contact: "راه های ارتباطی",
      users: "کاربران و پرسنل",
      messages: "پیام‌ها",
      tickets: "تیکت‌ها",
      support: "پشتیبانی",
      manageProducts: "مدیریت محصولات",
      products: "محصولات",
      orders: "سفارشات",
      addOrder: "ثبت سفارش",
      cart: "سبد خرید",
      shop: "فروشگاه",
      baseInformation: "اطلاعات پایه",
      reports: "گزارشات",
      editProfile: "ویرایش پروفایل",
      notifications: "اعلان و هشدار‌ها",
      allNotifications: "مشاهده همه اعلان‌ها",
      allMessages: "مشاهده همه پیام‌ها",
      logout: "خروج",
      rejectedTemplate: "کاربر مسدود شده",
      report: "گزارش ها",
      systemManagement: "مدیریت سامانه",
      roles: "نقش‌های کاربران",
      fiscalYear: "سال مالی",
      setting: "تنظیمات",
      user: "کاربران",
      activityGroup: "گروه فعالیت",
      internalUnit: "واحد داخلی",
      operation: "عملیات",
      person: "اشخاص",
      automationType: "انواع اتوماسیون",
      vehicle: "وسیله نقلیه",
      billboard: "بیلبورد",
      serviceType: "انواع خدمات",
      tariff: "تعرفه‌ها",
      waterBillPeriod: "دوره‌های قبض آب",
      subscriber: "مشترکین",
      notice: "اطلاعیه‌ها",
      transit: "لیست ترددها",
      addTransit: "ثبت تردد",
      fieldReport: "گزارش میدانی",
      meterReading: "قرائت",
      waterBill: "قبض آب",
      chargeBill: "قبض شارژ",
      automation: "اتوماسیون",
      billboardRequest: "درخواست بیلبورد",
      serviceRequest: "درخواست خدمات",
      transactionReport: "گزارش پرداخت ها",
      transactionInfo: "تنظیم تراکنشات",
      voucherCartable: "کارتابل صدور سند",
    },
    button: {
      login: "ورود به سامانه",
      register: "ثبت نام در سامانه",
      logout: "خروج از سامانه",
      recoveryEmail: "ارسال ایمیل بازیابی",
      submit: "ثبت",
      submitInfo: "ثبت اطلاعات",
      save: "ذخیره",
      saveChanges: "ثبت تغییرات",
      add: "ثبت جدید",
      edit: "ویرایش",
      delete: "حذف",
      confirmDelete: "بله، حذف شود",
      editProfile: "ویرایش پروفایل",
      editPassword: "ویرایش رمز عبور",
      send: "ارسال",
      back: "بازگشت",
      backToLogin: "بازگشت به صفحه ورود",
      backToHome: "بازگشت به صفحه اصلی",
      home: "صفحه اصلی",
      cancel: "انصراف",
      addBase: "ثبت اطلاعات پایه",
      reload: "بارگذاری مجدد",
      addActivityGroup: "ثبت گروه فعالیت",
      addInternalUnit: "ثبت واحد داخلی",
      addCountry: "ثبت کشور",
      addProvince: "ثبت استان",
      addCity: "ثبت شهر",
      closeWindow: "بستن پنجره",
      addUser: "ثبت کاربر",
      addRole: "ثبت نقش",
      addConfirm: "بله، تایید شود",
      changeStatus: "تغییر وضعیت",
      resetPassword: "بازنشانی رمزعبور",
      search: "جستجو",
      print: "چاپ",
      addAutomationType: "ثبت نوع اتوماسیون",
      addVehicle: "ثبت وسیله نقلیه",
      addBillboard: "ثبت بیلبورد",
      importExcel: "ورود اطلاعات از اکسل",
      importInfo: "ورود اطلاعات",
      addServiceType: "ثبت خدمت",
      addTariff: "ثبت تعرفه",
      addWaterBillPeriod: "ثبت دوره‌ قبض آب",
      addSubscriber: "ثبت مشترک",
      addNotice: "ثبت اطلاعیه‌",
      addTransit: "ثبت تردد جدید",
      exitAll: "خروج همه",
      exit: "خروج",
      addFieldReport: "ثبت گزارش میدانی",
      addMeterReading: "ثبت قرائت",
      addWaterBill: "ثبت قبض آب",
      payment: "پرداخت",
      confirmPayment: "بله، پرداخت شود",
      addChargeBill: "ثبت قبض شارژ",
      cashPayment: "پرداخت نقدی",
      cancellation: "ابطال",
      addAutomation: "ثبت اتوماسیون",
      changeUnit: "ارجاع به واحد دیگر",
      answer: "پاسخ",
      close: "بستن اتوماسیون",
      confirmClose: "بله، بسته شود",
      addBillboardRequest: "ثبت درخواست بیلبورد",
      addServiceRequest: "ثبت درخواست خدمات",
      uploadContract: "فایل قرارداد",
      deleteFile: "حذف فایل",
      saveFile: "ذخیره فایل",
      downloadFile: "فایل پیوست",
      showMore: "مشاهده بیشتر",
      approved: "تایید/رد",
      showAll: "مشاهده همه",
      importExcelAll: "ورود اطلاعات تمام فیلدها از اکسل",
      showDetail: "مشاهده جزئیات",
      verify: "تایید دستی",
      addVoucher: "صدور سند",
      showAnswer: "مشاهده پاسخ"
    },
    table: {
      row: "ردیف",
      actions: "عملیات",
      title: "عنوان",
      qty: "تعداد",
      category: "دسته بندی",
      subject: "موضوع",
      status: "وضعیت",
      username: "نام کاربری",
      role: "نقش کاربر",
      active: "فعال",
      inactive: "غیرفعال",
      code: "کد",
      country: "کشور",
      province: "استان",
      city: "شهر",
      firstName: "نام",
      lastName: "نام خانوادگی",
      fullName: "نام کامل",
      userName: "نام کاربری",
      nationalCode: "کدملی",
      userRole: "نقش کاربر",
      mobile: "تلفن همراه",
      phone: "تلفن ثابت",
      address: "آدرس",
      personType: "نوع کاربری",
      postalCode: "کد پستی",
      description: "توضیحات",
      date: "تاریخ",
      time: "ساعت",
      count: "تعداد",
      riskCoefficient: "ضریب ریسک",
      content: "محتوا",
      totalPrice: "مبلغ کل",
      creator: "کاربر ثبت",
      updater: "کاربر ویرایش",
      createdDate: "زمان ثبت",
      updateDate: "زمان ویرایش",
      type: "نوع",
      value: "مقدار",
      priority: "اولویت",
      internalUnit: "واحد داخلی",
      installationLocation: "محل نصب",
      technicalSpecifications: "مشخصات فنی",
      lightingSpecifications: "مشخصات روشنایی",
      price: "مبلغ",
      length: "طول",
      height: "ارتفاع",
      allowedPrice: "مبلغ مصرف مجاز/پایه",
      surplusPrice: "مبلغ مصرف غیرمجاز",
      subscription: "آبونمان",
      permittedConsumption: "مصرف مجاز",
      fromDate: "از تاریخ",
      toDate: "تا تاریخ",
      gender: "جنسیت",
      subscriber: "مشترک",
      contractNumber: "شماره قرارداد",
      brand: "نام تجاری",
      products: "محصولات",
      partNumber: "شماره قطعه",
      contractDate: "تاریخ قرارداد",
      activityGroup: "گروه فعالیت",
      nationalId: "شناسه ملی",
      area: "مساحت",
      blockNumber: "شماره بلوک",
      isWaterBill: "قبض آب",
      isChargeBill: "قبض شارژ",
      driverName: "نام راننده",
      driverMobile: "تلفن همراه راننده",
      vehicle: "وسیله نقلیه",
      productType: "نوع بار",
      productAmount: "مقدار محصول",
      plateNumber: "شماره پلاک",
      expireDate: "تاریخ انقضا",
      image: "فایل پیوست",
      waterBillPeriod: "دوره قبض آب",
      number: "شماره",
      startNumber: "شماره شروع",
      isReplacement: "تعویض کنتور",
      meterReading: "قرائت",
      isMeterInstallation: "نصب کنتور",
      amountPayable: "مبلغ قابل پرداخت",
      illegalConsumption: "مصرف غیرقانونی",
      illegalConsumptionPrice: "مبلغ مصرف غیرقانونی",
      lastNumberNo: "شماره قرائت قبلی",
      permittedConsumptionPrice: "مبلغ مصرف مجاز",
      previousDebt: "بدهی قبلی",
      sewagePrice: "مبلغ فاضلاب",
      tariffPermittedConsumption: "تعرفه مصرف مجاز",
      tariffPermittedConsumptionPrice: "مبلغ تعرفه مصرف مجاز",
      taxPrice: "مبلغ مالیات",
      waterPrice: "مبلغ آب",
      tariff: "عنوان تعرفه",
      meter: "کنتور",
      discountPrice: "مبلغ تخفیف",
      isSeen: "دیده شده",
      automationType: "نوع اتوماسیون",
      fromInternalUnit: "از واحد داخلی",
      toInternalUnit: "به واحد داخلی",
      unitCount: "واحد شمارش",
      unitPrice: "مبلغ واحد",
      serviceType: "نوع خدمت",
      paid: "پرداخت شده",
      pendingPay: "در انتظار پرداخت",
      billboardType: "نوع بیلبورد",
      dismantlingDate: "تاریخ جمع‌آوری",
      installDate: "تاریخ نصب",
      payStatus: "وضعیت پرداخت",
      vehicleType: "نوع وسیله نقلیه",
      exitDate: "تاریخ خروج",
      exitTime: "زمان خروج",
      exitDescription: "توضیحات خروج",
      exitUser: "کاربر ثبت خروج",
      approveDate: "تاریخ تایید/رد",
      approveDescription: "توضیحات تایید/رد",
      approved: "تایید شده",
      reply: "پاسخ به اتوماسیون",
      sewagePercent: "درصد فاضلاب",
      rowNumber: "شماره سطر",
      errorDescription: "شرح خطا",
      isDiscountPaymentOnTime: "شامل تخفیف خوش حسابی",
      hasTax: "شامل مالیات",
      paymentDeadline: "مهلت پرداخت",
      payType: "نوع پرداخت",
      transactionNumber: "شماره تراکنش",
      day: "روز",
      insertType: "نوع ورود داده",
      paymentProcess: "فرایند پرداخت",
      creditAccount: "حساب بستانکار",
      debtAccount: "حساب بدهکار",
      projectCode: "کد پروژه",
      projectTitle: "عنوان پروژه",
    },
    form: {
      firstName: "نام",
      lastName: "نام خانوادگی",
      fullName: "نام کامل",
      userName: "نام کاربری",
      password: "رمز عبور",
      repeatPassword: "تکرار رمز عبور",
      currentPassword: "رمز عبور فعلی",
      newPassword: "رمز عبور جدید",
      email: "پست الکترونیک",
      mobile: "تلفن همراه",
      tel: "شماره تماس",
      phone: "تلفن ثابت",
      address: "آدرس",
      postalCode: "کد پستی",
      otpCode: "کد احراز هویت (کد تأیید)",
      image: "تصویر",
      file: "فایل",
      fileSize: "حداکثر حجم مجاز",
      fileType: "پسوندهای مجاز",
      fileRatio: "تصویر در ابعاد مربعی انتخاب کنید",
      department: "دپارتمان",
      birthDate: "تاریخ تولد",
      description: "توضیحات",
      message: "متن پیام",
      subject: "موضوع",
      title: "عنوان",
      qty: "تعداد",
      digit: "عدد",
      category: "دسته بندی",
      role: "نقش کاربر",
      productName: "نام / عنوان محصول",
      annualDemand: "مقدار نیاز سالانه",
      sbu: "واحد کسب و کار (SBU)",
      resell: "فروش مجدد",
      weight: "وزن مخصوص",
      sendDate: "تاریخ ارسال",
      productDate: "تاریخ تولید",
      paymentMethod: "نحوه پرداخت",
      cashOption: "پرداخت نقدی",
      chequeOption: "چک بانکی",
      attachment: "فایل پیوست",
      code: "کد",
      country: "کشور",
      province: "استان",
      city: "شهر",
      nationalCode: "کدملی",
      userRole: "نقش کاربر",
      active: "فعال",
      inactive: "غیرفعال",
      status: "وضعیت",
      riskCoefficient: "ضریب ریسک",
      date: "تاریخ",
      time: "ساعت",
      count: "تعداد",
      brandName: "نام تجاری",
      content: "محتوا",
      totalPrice: "مبلغ کل",
      fromDate: "از تاریخ",
      toDate: "تا تاریخ",
      type: "نوع",
      value: "مقدار",
      priority: "اولویت",
      fiscalYear: "سال مالی",
      internalUnit: "واحد داخلی",
      sheetName: "نام شیت",
      installationLocation: "محل نصب",
      technicalSpecifications: "مشخصات فنی",
      lightingSpecifications: "مشخصات روشنایی",
      price: "مبلغ",
      length: "طول",
      height: "ارتفاع",
      allowedPrice: "مبلغ مصرف مجاز",
      surplusPrice: "مبلغ مصرف غیرمجاز",
      subscription: "آبونمان",
      permittedConsumption: "مصرف مجاز",
      gender: "جنسیت",
      subscriber: "مشترک",
      contractNumber: "شماره قرارداد",
      brand: "نام تجاری",
      products: "محصولات",
      partNumber: "شماره قطعه",
      contractDate: "تاریخ قرارداد",
      activityGroup: "گروه فعالیت",
      nationalId: "شناسه ملی",
      area: "مساحت",
      blockNumber: "شماره بلوک",
      isWaterBill: "قبض آب",
      isChargeBill: "قبض شارژ",
      driverName: "نام راننده",
      driverMobile: "تلفن همراه راننده",
      vehicle: "وسیله نقلیه",
      productType: "نوع بار",
      productAmount: "مقدار محصول",
      plateNumber: "پلاک",
      exitDate: "تاریخ خروج",
      exitTime: "زمان خروج",
      expireDate: "تاریخ انقضا",
      waterBillPeriod: "دوره قبض آب",
      number: "شماره",
      startNumber: "شماره شروع",
      isReplacement: "تعویض کنتور",
      meterReading: "قرائت",
      isMeterInstallation: "نصب کنتور",
      transactionNumber: "شماره تراکنش",
      automationType: "نوع اتوماسیون",
      answer: "پاسخ",
      unitCount: "واحد شمارش",
      unitPrice: "مبلغ واحد",
      serviceType: "نوع خدمت",
      discountPrice: "مبلغ تخفیف",
      billboardType: "نوع بیلبورد",
      dismantlingDate: "تاریخ جمع‌آوری",
      installDate: "تاریخ نصب",
      vehicleType: "نوع وسیله نقلیه",
      basePrice: "مبلغ پایه",
      reject: "رد",
      approved: "تایید",
      meterReadingDate: "تاریخ قرائت",
      amountPayable: "مبلغ قابل پرداخت",
      tariff: "تعرفه",
      meterReadingNumber: "شماره قرائت",
      reply: "پاسخ به اتوماسیون",
      sewagePercent: "درصد فاضلاب",
      personType: "نوع کاربری",
      chargeBillForAll: "صدور قبض برای تمام مشترکین",
      isDiscountPaymentOnTime: "شامل تخفیف خوش حسابی",
      hasTax: "شامل مالیات",
      tariffPermittedConsumption: "تعرفه مصرف مجاز",
      tariffPermittedConsumptionPrice: "مبلغ تعرفه مصرف مجاز",
      meterNo: "شماره کنتور",
      lastNumberNo: "شماره قرائت قبلی",
      permittedConsumptionPrice: "مبلغ مصرف مجاز",
      illegalConsumption: "مصرف غیرقانونی",
      illegalConsumptionPrice: "مبلغ مصرف غیرقانونی",
      sewagePrice: "مبلغ فاضلاب",
      waterPrice: "مبلغ آب",
      previousDebt: "بدهی قبلی",
      taxPrice: "مبلغ مالیات",
      paymentDeadline: "مهلت پرداخت",
      paymentProcess: "فرایند پرداخت",
      creditAccount: "حساب بستانکار",
      debtAccount: "حساب بدهکار",
      projectCode: "کد پروژه",
      projectTitle: "عنوان پروژه",
      isNewVoucher: "سند جدید",
      addToVoucher: "اضافه به سند",
      isToLastVoucher: "اضافه به سند آخر",
      voucherNo: "شماره سند",
      voucherDate: "تاریخ سند",
      voucherCover: "روکش سند",
      payType: "نوع پرداخت",
      trackingCode: "کد پیگیری"
    },
    caption: {
      yes: "بله",
      no: "خیر",
      ok: "تایید",
      dashboard: "داشبورد مدیریتی",
      profile: "ویرایش اطلاعات و رمز عبور حساب کاربری",
      password: "تغییر رمز عبور",
      avatar: "تصویر پروفایل کاربری",
      baseInformation: "اطلاعات و تنظیمات ابتدایی سامانه",
      addBaseInformation: "ثبت اطلاعات پایه جدید",
      editBaseInformation: "ویرایش اطلاعات پایه",
      users: "مدیریت کاربران سامانه",
      addUser: "ثبت کاربر جدید",
      editUser: "ویرایش اطلاعات کاربر",
      products: "مدیریت محصولات و تولیدات",
      orders: "مدیریت و بررسی سفارشات",
      messages: "پیام‌ها و چت کاربران",
      tickets: "پیام‌ها و درخواست‌های مشتریان",
      loading: "در حال بارگذاری ...",
      singIn: "ورود به سامانه",
      singUp: "عضویت در سامانه",
      haveAccount: "حساب کاربری دارید؟",
      haveNotAccount: "حساب کاربری ندارید؟",
      forgotPassword: "رمز عبور را فراموش کرده‌اید؟",
      emptyItem: "موردی جهت نمایش یافت نشد",
      emptyMessage: "لیست پیام‌های شما خالی می‌باشد",
      emptyTicket: "لیست تیکت‌های شما خالی می‌باشد",
      emptyNotify: "لیست اعلان‌ و هشدارها خالی می‌باشد",
      noMessage: "پیام جدیدی دریافت نکردید",
      noNotify: "اعلان جدیدی وجود ندارد",
      underConstruction:
        "این قسمت در حال توسعه می‌باشد و بزودی در دسترس قرار خواهد گرفت",
      rejectedTitle: "عدم دسترسی به سامانه",
      rejectedText: "حساب کاربری شما در این سامانه مسدود شده است",
      search: "جستجو",
      searchTable: "جستجو در جدول",
      searchAllColumns: "جستجو در همه ستون‌ها",
      delConfirm: "از حذف این مورد مطمئن هستید؟",
      resell: "آیا محصول برای فروش مجدد هست؟",
      addCountry: "ثبت کشور جدید",
      editCountry: "ویرایش اطلاعات کشور",
      addProvince: "ثبت استان جدید",
      editProvince: "ویرایش اطلاعات استان",
      addCity: "ثبت شهر جدید",
      editCity: "ویرایش اطلاعات شهر",
      roles: "مدیریت نقش‌ها و دسترسی‌های کاربران",
      addRole: "ثبت نقش",
      editRole: "ویرایش اطلاعات نقش",
      real: "حقیقی",
      legal: "حقوقی",
      percent: "درصد",
      changeStatusUser: "آیا از تغییر وضعیت این کاربر مطمئن هستید؟",
      resetPassword: "بازنشانی رمزعبور",
      searchItems: "جستجوی آیتم‌ها",
      logoutConfirm: "از خروج مطمئن هستید؟",
      editSetting: "ویرایش تنظیمات",
      addPerson: "ثبت شخص جدید",
      editPerson: "ویرایش اطلاعات شخص",
      addActivityGroup: "ثبت گروه فعالیت جدید",
      editActivityGroup: "ویرایش اطلاعات گروه فعالیت",
      addInternalUnit: "ثبت واحد داخلی جدید",
      editInternalUnit: "ویرایش اطلاعات واحد داخلی",
      addAutomationType: "ثبت نوع اتوماسیون جدید",
      editAutomationType: "ویرایش اطلاعات نوع اتوماسیون",
      addVehicle: "ثبت وسیله نقلیه جدید",
      editVehicle: "ویرایش اطلاعات وسیله نقلیه",
      importExcel: "ورود اطلاعات از اکسل",
      addServiceType: "ثبت خدمت جدید",
      editServiceType: "ویرایش اطلاعات خدمت",
      addWaterBillPeriod: "ثبت دوره‌ قبض آب جدید",
      editWaterBillPeriod: "ویرایش اطلاعات دوره‌ قبض آب",
      exitTransit: "خروج از تردد",
      addMeterReading: "ثبت قرائت جدید",
      editMeterReading: "ویرایش اطلاعات قرائت",
      addWaterBill: "ثبت قبض آب جدید",
      editWaterBill: "ویرایش اطلاعات قبض آب",
      paymentConfirm: "آیا از پرداخت این مورد مطمئن هستید؟",
      paymentResult: "نتیجه تراکنش",
      addChargeBill: "ثبت قبض شارژ جدید",
      editChargeBill: "ویرایش اطلاعات قبض شارژ",
      payBill: "پرداخت قبض",
      changeStatusSubscriber: "آیا از تغییر وضعیت این مشترک مطمئن هستید؟",
      cancelConfirm: "از ابطال این مورد مطمئن هستید؟",
      list: "لیست",
      cartable: "کارتابل",
      automationAnswer: "پاسخ به اتوماسیون",
      changeInternalUnit: "ثبت ارجاع به واحد دیگر",
      automationCloseConfirm: "از بستن این اتوماسیون مطمئن هستید؟",
      changeStatus: "تغییر وضعیت",
      uploadContract: "آپلود فایل قرارداد",
      notice: "اطلاعیه‌ها",
      showNoticeDetail: "جزئیات و نمایش کامل اطلاعیه",
      approvedMeterReading: "تایید/رد قرائت",
      billboardReserveDate: "روزهای رزرو شده",
      showSubscriberDetail: "مشاهده جزئیات مشترک",
      verify: "تایید دستی",
      addVoucher: "صدور سند",
      voucherInfo: "اطلاعات سند",
      showAnswer: "مشاهده پاسخ"
    },
    validation: {
      required: "الزامی",
      email: " ایمیل را بصورت صحیح وارد کنید",
      zipCodeLength: "تعداد مجاز 10 رقم می‌باشد",
    },
  };
}

export default label;
